import { Navigate } from "react-router-dom";
import { useCmsAuth } from "../context/CmsAuthContext";

/** Bloquea la ruta si el usuario no tiene el módulo. */
export default function CmsModuleGate({ module, children }) {
  const { hasModule, loading } = useCmsAuth();
  if (loading) return null;
  if (!hasModule(module)) return <Navigate to="/admin" replace />;
  return children;
}
